// Libs
import React, { useContext, useEffect, useState } from 'react'
import { Tooltip } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
    AnexoDemanda,
    Demanda,
    downloadAnexoDemandaPecaOrcamentaria,
    getAnexosPecaOrcamentaria,
    updateDemanda
} from '@app/api/demanda';
import { getAllCentroCustoOptions } from '@app/api/centrocusto';
import { getTipoServicoOptions } from '@app/api/tipoServico';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasByDiretoriaOptions } from '@app/api/area';
import { getAllDepartamentoProAreaIdOptions } from '@app/api/departamento';

//Files
import CurrencyInput from "@app/components/CurrencyInput";
import { UploadComponent } from '@app/components';

//Utils
import {optionsSwitch} from '@app/helpers/optionsSwitch';
import { hasPermission } from '@app/helpers/permissions';
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { InputLabel } from '@app/components';
import ModalComentariosAnexoFormularioReqCompra from '../QuestionarioContratacao/ModalComentariosAnexoFormularioReqCompra';
import ModalInlcuirAnexoPecaOrcamentaria from './ModalInlcuirAnexoPecaOrcamentaria';
import ModalComentariosCampoDemanda from './ModalComentariosCampoDemanda';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { EGuidModalComentario } from '@app/enums/EGuidModalComentario';
import { Visibility } from '@app/components';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import ModalSelectItemServico from '../QuestionarioContratacao/ModalSelectItemServico';
import AnaliseDemandaHistoricoModificacao from './AnaliseDemandaHistoricoModificacao';

interface IProps {
    update: boolean;
    setUpdate: (value: boolean) => void;
}

function ValidacaoControladoriaAnaliseDemandaPage({ update, setUpdate }: IProps) {

    const [tipoDespesa, setTipoDespesa] = useState('');

    const [anexoFormularioReqCompra, setAnexoFormularioReqCompra] = useState<AnexoDemanda>({} as AnexoDemanda);
    const [anexosConfirmacaoPrevisaoOrcamentaria, setAnexosConfirmacaoPrevisaoOrcamentaria] = useState([]);

    const [departamentos, setDepartamentos] = useState<ui.OptionProps[]>();
    const [areas, setAreas] = useState<ui.OptionProps[]>();

    const {
        demandaData,
    } = useContext(QuestionarioContextProvider);

    useEffect(() => {
        if (!demandaData) {
            return;
        }

        if (demandaData.capex) {
            setTipoDespesa('capex');
        } else if (demandaData.opex) {
            setTipoDespesa('opex');
        } else if (demandaData.contaResultado) {
            setTipoDespesa('resultado');
        }

        let anexo = demandaData.anexosDemanda
            && demandaData.anexosDemanda.find(a => a.descricaoDocumento.includes('Formulário de Requisição de Compras'))
            || {} as AnexoDemanda;

        setAnexoFormularioReqCompra(anexo);

        getAnexosPecaOrcamentaria(demandaData.id)
            .then((data: any) => setAnexosConfirmacaoPrevisaoOrcamentaria(data));

        getAllAreasByDiretoriaOptions(demandaData.diretoriaId)
            .then(data => {
                let areas = [...data, { text: 'N/A', value: 'na' }];
                setAreas(areas);
            });
        getAllDepartamentoProAreaIdOptions(demandaData.areaId)
            .then(data => {
                let departamentos = [...data, { text: 'N/A', value: 'na' }];
                setDepartamentos(departamentos);
            });

    }, [demandaData]);


    const onUpdateDemanda = (demanda: Demanda) => {
        updateDemanda(demanda).then((resp: any) => {
            if (resp.valid) {
                onUpdate();
            }
        });
    }
    const onUpdate = () => {
        setUpdate(!update);
    };


    const columnsAnexoPrevisaoOrcamentaria = [
        {
            title: 'Descrição',
            dataIndex: 'descricaoDocumento',
            width: '45%',
        },
        {
            title: 'Arquivo',
            dataIndex: 'nome',
        },
        {
            title: 'Ações',
            width: '10%',
            className: 'td-centralizado',
            render: (index: any, record: any) => (
                <>
                    {record && (
                        <>
                            {hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO']) && (
                                <Tooltip title="Adicionar Arquivo">
                                    <UploadComponent
                                        nomeIdFormulario={'id'}
                                        key={record.id}
                                        id={record.id}
                                        retorno={() => onUpdate()}
                                        iconName={'ui-upload'}
                                        idDoComponente={record.id}
                                        hasFile={false}
                                        enderecoApi={'anexoDemanda/UploadAnexoConfirmacaoPrevisaoOrcamentaria'}
                                    />
                                </Tooltip>
                            )}
                            <Tooltip title="Download Arquivo">
                                <ui.Button
                                    id='mrn-download-anexo-peca-orcamentaria'
                                    icon="ui-download"
                                    type="link"
                                    onClick={() => {
                                        downloadAnexoDemandaPecaOrcamentaria(record.id, record.nome);
                                    }}
                                />
                            </Tooltip>
                        </>
                    )}
                </>
            ),
        },
        {
            title: 'Comentários',
            dataIndex: 'historicoComentariosAnexoDemanda',
            width: '10%',
            className: 'td-centralizado',
            render: (index: any, record: any) => {
                return (
                    <ModalComentariosAnexoFormularioReqCompra
                        preSuprimentos={false}
                        anexoId={record.id}
                        contemComentario={record.contemComentarios}
                    />
                );
            },
        },
    ];

    if (!demandaData) {
        return (<></>);
    }

    const emModificacao = !!demandaData && !!demandaData.isModificando;

    const renderWidget = () => (
        <ui.Widget>
            <ui.Row>
                <ui.FormSelect
                    label="Diretoria"
                    name="diretoriaId"
                    id='mrn-select-diretoria'
                    placeholder="Selecione uma opção"
                    getOptions={getAllDiretoriasOptions}
                    value={demandaData.diretoriaId}
                    span={4}
                    disabled
                />
                <ui.FormSelect
                    label="Área"
                    name="areaId"
                    id='mrn-select-area'
                    placeholder="Selecione uma opção"
                    options={areas}
                    span={4}
                    value={demandaData.areaId}
                    disabled
                />

                <ui.FormSelect
                    label="Departamento"
                    name="departamentoId"
                    id='mrn-select-departamento'
                    placeholder="Selecione uma opção"
                    options={departamentos}
                    value={demandaData.departamentoId}
                    span={4}
                    disabled
                />
            </ui.Row>

            <ui.Row>
                <ui.FormSelect
                    label="Tipo"
                    name="tipo"
                    id='mrn-select-tipo'
                    span={4}
                    options={[
                        { value: 1, text: 'Nova Contratação' },
                        { value: 2, text: 'Aditivo' },
                        { value: 3, text: 'Acordo de Fornecimento' },
                        { value: 4, text: 'Faturamento Direto' },
                        { value: 5, text: 'Aditivo Faturamento Direto' },
                    ]}
                    disabled
                    value={demandaData.tipo}
                />

                <Visibility
                    visible={demandaData.tipo === ETipoDemanda.NovaContratacao}
                >
                    <ui.FormSelect
                        id="mrn-select-tipoServico"
                        label="Tipo de Serviço"
                        name="tipoServicoId"
                        span={4}
                        getOptions={getTipoServicoOptions}
                        disabled
                    />

                    <ui.FormSelect
                        id='mrn-select-haveraMaoDeObraEmPTR'
                        options={optionsSwitch}
                        label="Haverá parte ou totalidade da Mão-de-obra em PTR?"
                        name="haveraMaoDeObraEmPTR"
                        span={4}
                        disabled
                    />
                </Visibility>

                <Visibility
                    visible={demandaData.tipo === ETipoDemanda.Aditivo}
                >
                    <ui.FormSelect
                        label="Escolha o Tipo de Contrato"
                        name="tipoContrato"
                        id='mrn-select-tipoContrato'
                        options={[
                            { value: 'contrato', text: 'Contrato' },
                            { value: 'pcs', text: 'PCS – Pedido de Compra de Serviço' },
                        ]}
                        span={4}
                        required
                        disabled
                    />
                </Visibility>
            </ui.Row>

            <ui.Row>
                <ui.FormTextArea
                    id="mrn-textarea-objetoASerContratado"
                    name="objeto"
                    label="Objeto a Ser Contratado"
                    rows={1}
                    disabled
                    value={demandaData.objeto}
                />
            </ui.Row>

            <ui.Row>
                <CurrencyInput
                    name="valorTotalContratacao"
                    id='mrn-input-valorTotalContratacao'
                    label="Valor Total Contratação"
                    disabled
                    span={demandaData.tipo === ETipoDemanda.NovaContratacao ? 4 : 2}
                    value={demandaData.tipo === ETipoDemanda.NovaContratacao 
                        ? demandaData.expectativaValorFinal  
                        : demandaData.novoValorFinal}
                />
                <Visibility
                    visible={demandaData.tipo === ETipoDemanda.Aditivo}
                >
                    <CurrencyInput
                        name="valorAditivo"
                        id='mrn-input-valorAditivo'
                        label="Valor Aditivo"
                        disabled
                        span={2}
                        value={demandaData.valorAditivo}
                    />
                </Visibility>

                <Visibility
                    visible={demandaData.tipo === ETipoDemanda.NovaContratacao}
                >
                    <ui.FormInput
                        name="prazo"
                        label="Prazo (em meses)"
                        id='mrn-input-prazo'
                        disabled
                        span={4}
                        value={demandaData.expectativaDePrazo}
                    />
                </Visibility>
                <ui.FormSelect
                    label="Tipo de Despesa"
                    span={4}
                    value={tipoDespesa}
                    name="tipoDespesa"
                    id='mrn-select-tipoDespesa'
                    options={[
                        { text: 'CAPEX', value: 'capex' },
                        { text: 'OPEX', value: 'opex' },
                        { text: 'Conta de Resultado', value: 'resultado' },
                    ]}
                    disabled
                />
            </ui.Row>

            <ui.Row>
                <ModalSelectItemServico disabled={true} span={6} itemServicoSelecionado={demandaData.codItemServico} />
                <ui.FormSelect
                    label="Centro de Custo"
                    name="codCentroDeCusto"
                    id='mrn-select-centroDeCusto'
                    span={2}
                    value={demandaData.codCentroDeCusto}
                    getOptions={getAllCentroCustoOptions}
                    disabled
                />
                <ui.FormInput
                    label="Centro de Custo"
                    name="centroDeCusto"
                    id='mrn-input-centroDeCusto'
                    value={demandaData.centroDeCusto}
                    span={4}
                    disabled />
            </ui.Row>

            <ui.Row>
                <ui.FormInput
                    label="Id orçamento"
                    name='orcamentoId'
                    id='mrn-input-orcamentoId'
                    span={4} disabled />
                <ui.Row>
                    <ui.FormSelect
                        id='mrn-select-temPrevisaoOrcamentaria'
                        options={optionsSwitch}
                        label="Está previsto na peça Orçamentária?"
                        name="temPrevisaoOrcamentaria"
                        span={4}
                        required
                        onSelect={value => {
                            let dem = { ...demandaData, temPrevisaoOrcamentaria: value } as Demanda;
                            onUpdateDemanda(dem);
                        }}
                        disabled={
                        [
                            EStatusDemanda.AguardandoAnaliseControladoria,
                            EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
                            EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
                        ].includes(demandaData.statusCodigo || 0) === false}
                    />

                    <InputLabel
                        label=''
                        span={4}
                    >
                        <ModalInlcuirAnexoPecaOrcamentaria
                            demandaId={demandaData.id}
                            statusCodigo={demandaData.statusCodigo || 0}
                        />

                        <ModalComentariosCampoDemanda
                            idDoComponente='mrn-modal-ModalComentariosCampoDemanda-PecaOrcamentaria'
                            preSuprimentos={true}
                            campoId={EGuidModalComentario.ESCLARECIMENTO_PREVISAO_ORCAMENTARIA}
                            key={demandaData.id}
                            demandaId={demandaData.id}
                            disabled={!hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONTROLADORIA_RESPONSAVEL_VALIDACAO'])}
                        />
                    </InputLabel>

                </ui.Row>
            </ui.Row>

        </ui.Widget>
    )

    const renderWidgetModificacao = () => (
        <>
            <AnaliseDemandaHistoricoModificacao />

            <ui.Row>
                <ModalSelectItemServico disabled={true} span={6} itemServicoSelecionado={demandaData.codItemServico} />
                <ui.FormSelect
                    label="Centro de Custo"
                    name="codCentroDeCusto"
                    id='mrn-select-centroDeCusto'
                    span={2}
                    value={demandaData.codCentroDeCusto}
                    getOptions={getAllCentroCustoOptions}
                    disabled
                />
                <ui.FormInput
                    label="Centro de Custo"
                    name="centroDeCusto"
                    id='mrn-input-centroDeCusto'
                    value={demandaData.centroDeCusto}
                    span={4}
                    disabled />
            </ui.Row>

            <ui.Row>
                {
                    demandaData.opex &&
                    <ui.FormInput
                        label="Ordem de Manutenção"
                        name="ordemManutencao"
                        id='mrn-input-ordemManutencao'
                        value={demandaData.ordemManutencao}
                        span={2}
                        disabled />
                }
                <ui.FormInput
                    label="Id orçamento"
                    name='orcamentoId'
                    id='mrn-input-orcamentoId'
                    span={4} disabled />
                <ui.FormSelect
                    id='mrn-select-temPrevisaoOrcamentaria'
                    options={optionsSwitch}
                    label="Está previsto na peça Orçamentária?"
                    name="temPrevisaoOrcamentaria"
                    span={4}
                    required
                    onSelect={value => {
                        let dem = { ...demandaData, temPrevisaoOrcamentaria: value } as Demanda;
                        onUpdateDemanda(dem);
                    }}
                    disabled={[
                        EStatusDemanda.AguardandoAnaliseControladoria,
                        EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
                        EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
                    ].includes(demandaData.statusCodigo || 0) === false}
                />

                <InputLabel
                    label=''
                    span={2}
                >
                    <ModalInlcuirAnexoPecaOrcamentaria
                        demandaId={demandaData.id}
                        statusCodigo={demandaData.statusCodigo || 0}
                    />

                    <ModalComentariosCampoDemanda
                        idDoComponente='mrn-modal-ModalComentariosCampoDemanda-PecaOrcamentaria'
                        preSuprimentos={true}
                        campoId={EGuidModalComentario.ESCLARECIMENTO_PREVISAO_ORCAMENTARIA}
                        key={demandaData.id}
                        demandaId={demandaData.id}
                        disabled={!hasPermission(['PRE_SUPRIMENTOS_DEMANDA_CONTROLADORIA_RESPONSAVEL_VALIDACAO'])}
                    />
                </InputLabel>

            </ui.Row>
        </>
    );

    return (
        <ui.Row>
            <ui.MasterDetailForm
                initialValues={demandaData}
            >
                <ui.FormContext.Consumer>
                    {({ formProps }) => (
                        <fieldset>
                            <legend>Validação Controladoria</legend>
                            {emModificacao === false && renderWidget()}
                            {emModificacao && renderWidgetModificacao()}
                        </fieldset>
                    )}
                </ui.FormContext.Consumer>
            </ui.MasterDetailForm>
        </ui.Row>
    )
}

export default ValidacaoControladoriaAnaliseDemandaPage
